// extracted by mini-css-extract-plugin
export default {"container":"layout_container__Iz5wn","header":"layout_header__R6S4J"};